import { render, staticRenderFns } from "./AppBox.vue?vue&type=template&id=b65cfa4c&scoped=true&"
import script from "./AppBox.vue?vue&type=script&lang=js&"
export * from "./AppBox.vue?vue&type=script&lang=js&"
import style0 from "./AppBox.vue?vue&type=style&index=0&id=b65cfa4c&scoped=true&lang=css&"
import style1 from "./AppBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65cfa4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VList,VListItem,VMenu})
